import { PresentationSummaryModalProps } from './PresentationSummaryModal';
import { openModal } from '@core/components/ModalStack';

export async function openPresentationSummaryModal(props: PresentationSummaryModalProps) {
  const { PresentationSummaryModal } = await import('./PresentationSummaryModal');

  openModal(PresentationSummaryModal, props);
}
